import { OnInit, Component } from "@angular/core";
import { PatientView } from "../../../model/patient/patient-view";
import { MedicalServiceWizardService } from "../../../services/wizard/medical-service/medical-service-wizard";
import { WizardStep } from "../../../wizard/wizard.component";
import { NotificationToastService } from "../../../services/notification-toast.service";


@Component({
  selector: 'medical-service-patient-component',
  templateUrl: './medical-service-patient.component.html',
  styleUrls: ['./medical-service-patient.component.css']
})
export class MedicalServicePatientComponent implements OnInit, WizardStep {

  loading: boolean;
  completed: boolean;
  isInit: boolean;
  patient: PatientView;

  constructor(private medicalServiceWizardService: MedicalServiceWizardService
    , private notificationToastService: NotificationToastService) {
  }

  activate(): void {
  }

  save(): void {
  }

    get valid(): boolean {
    return this.completed;
  }


  async ngOnInit() {
    try {
      this.loading = true;
      this.patient = await this.medicalServiceWizardService.getPatientView();
      this.completed = true;
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Paciente');
    } finally {
      this.loading = false;
    }
  }
}
